import { ModelBase } from 'store/model-base';

export class NowUser extends ModelBase {
    public static storeName: string = 'nowUser';

    public nowEligibility: boolean;
    public isNowUser: boolean;

    public static create<T extends ModelBase>(initData: object): T {
        const toReturn: NowUser = super.create<NowUser>(initData);
        toReturn.isNowUser = toReturn.nowEligibility;

        return super.create<T>(toReturn);
    }
}
